import styled from '@rsos/theme/styled';

export const StyledHUD = styled.div`
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.35) 0,
    rgba(0, 0, 0, 0) 125px
  );
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

export const StyledHUDMessages = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 9px;
`;
